// Reading failures. The api answers problem+json everywhere except better-auth's `/v1/auth/*`, which
// answers `{ code, message }` (spec/08 §2.6); the generated client raises the two as `ApiProblemError`
// and `ApiAuthError`, and anything else as a transport failure. A trimmed copy of the console's
// (apps/console/src/api/problems.ts): the portal branches on far fewer codes.

import { ApiAuthError, ApiProblemError } from '@clavian/api-client';
import type { ErrorCode } from '@clavian/contracts';

export function problemCode(error: unknown): string | undefined {
  if (error instanceof ApiProblemError || error instanceof ApiAuthError) return error.code;
  return undefined;
}

export function problemStatus(error: unknown): number | undefined {
  if (error instanceof ApiProblemError || error instanceof ApiAuthError) return error.status;
  return undefined;
}

/** A read that resolved to nothing: a venue that is not listed, or not live (spec/08). */
export const isNotFound = (error: unknown): boolean => problemStatus(error) === 404;

/**
 * The problem codes the portal branches on: the contract's error catalogue, snake_case. Each is checked against the
 * catalogue's own list (`ErrorCode`), so a code the server never sends (a misspelling, or the kebab-case slug) fails
 * to compile rather than silently never matching.
 */
export const PROBLEM = {
  conflict: 'conflict',
  notFound: 'not_found',
  validationFailed: 'validation_failed',
  reauthenticationRequired: 'reauthentication_required',
  sessionAlreadyEnded: 'session_already_ended',
  signInHandoffUnavailable: 'sign_in_handoff_unavailable',
  playerBanned: 'player_banned',
  carriedOverEmailMismatch: 'carried_over_email_mismatch',
  carriedOverCounterOnly: 'carried_over_counter_only',
  accountAlreadyLinked: 'account_already_linked',
  contactInUse: 'contact_in_use',
  signUpDisabled: 'sign_up_disabled',
  notOnSite: 'not_on_site',
  rateLimited: 'rate_limited',
  unauthenticated: 'unauthenticated',
} as const satisfies Record<string, ErrorCode>;
